import React, {useEffect, useState} from "react";
import {checkPermission, clearEmptyValuesFromObject, getKeyByName, isEmpty} from "../../../_helpers/commonFunctions";
import {
    deleteObjectFromArrayOfObjects,
} from "../../../_helpers/helperFunctions";
import TableBodyRow from "./TableBodyRow";
import TableFilterRow from "./TableFilterDataRow";
import TableInsertDataRow from "./TableInsertDataRow";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import axios from "axios";
import {
    setClientMovementsSearchByBalance,
} from "../../../_reducers/DataPanel/Clients/clientSlice";
import {
   setProductMovementsReportDataByBalance,
} from "../../../_reducers/DataPanel/Products/productsSlice";
import {
    setSupplierMovementsSearchByBalance
} from "../../../_reducers/DataPanel/Suppliers/supplierSlice";
import {
    setDrugInfoModal,
} from "../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import {openPrescription, openReferral} from "../../layouts/data-panel/Prescriptions/prescriptionFunctions";
import {
    openAccountingAccountLocal,
    openAccountingRecordLocal,
    openAdvancedTypeLocal,
    openBankAccountLocal,
    openBasicTypeLocal,
    openBuy,
    openBuyLocal,
    openCashRegisterLocal,
    openClient,
    openClientLocal,
    openClientMovementLocal, openClientMovementsReport,
    openClientPayment,
    openClientPaymentLocal,
    openDCLLocal, openEditVisit,
    openEmployeeLocal,
    openFixedAssetLocal,
    openFixedAssetMovementLocal,
    openFixedAssetRecordLocal,
    openPOSLocal,
    openPriceListLocal,
    openProductLocal,
    openProductMovementLocal, openProductMovementsReport,
    openSale,
    openSaleLocal,
    openQuotationLocal,
    openSupplierLocal,
    openSupplierMovementLocal,
    openSupplierMovementsReport,
    openSupplierPayment,
    openSupplierPaymentLocal,
    openWorkMovementLocal,
    openWorkPermitLocal, openChequeLocal, openLoanLocal,
    openSubmittedVatDeclarationLocal, openSubmittedF4DeclarationLocal, openSubmittedF5DeclarationLocal,
    openDebtLocal, openCardLocal
} from "../../../_helpers/tabOpeners";
import {useTranslation} from "../../../hooks/useTranslation";

const TableBody = (props) => {
    const {t} = useTranslation();
    const {
        data,
        columns,
        allowInsertRow,
        allowInsertRowFromTop,
        selectedRow,
        tableName,
        allowFilterTable,
        checkedRows,
        selectedRowKey,
        quickEditCustomColumns,
        pRequestData,
        reqName,
        emronPaymentsMonth,
        showAccounting,
        invoiceType,
        fixedFirstRow,
        permissionsData,
    } = props;
    const [bodyData, setBodyData] = useState(data);
    const [filters, setFilters] = useState({});
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const dispatch = useDispatch();

    useEffect(() => {
        setBodyData(data);
    }, [data])

    // This is used on Table Filter Cell
    const filterFieldValue = (value, field) => {
        // Add the value ot new filter
        let filter = {[field]: value}
        let newFilters = {...filters, ...filter};
        setFilters(newFilters);

        // Filter Data
        let filteredData = filterTableBodyData(data, newFilters);
        if (Object.keys(newFilters).length <= 0) {
            setBodyData(data);
        } else {
            setBodyData(filteredData);
        }
    }

    const filterTableBodyData = (data, filter) => {

        data = deleteObjectFromArrayOfObjects(data, null, '_id') // remove if there is any null value
        filter = clearEmptyValuesFromObject(filter); // clear empty fields

        return data.filter(function (item) {
            let returnType = true;
            for (const key in filter) {
                if (key) {
                    let itemVal = item[key]?.toString().toLowerCase().trim();
                    let filterVal = filter[key]?.toString().toLowerCase().trim();

                    if (key === 'isActive') {
                        // Exact Match Case
                        if (item[key] === undefined || (itemVal !== filterVal)) {
                            returnType = false;
                        }
                    } else {
                        // Normal Case for input
                        if (
                            item[key] === undefined ||
                            (
                                itemVal !== filterVal &&
                                // itemVal !== "" && // Fix for empty values on filter
                                !itemVal?.includes(filterVal) &&
                                !itemVal?.startsWith(filterVal) &&
                                !itemVal?.endsWith(filterVal)
                            )
                        ) {
                            returnType = false;
                        }
                    }
                }
            }
            return returnType;
        });
    }

    const selectRow = (e, data, rowIndex) => {
        // It will select the row on single click
        if (tableName === 'Product Variants') {
            if (e.detail === 2) {
                props.onRowSelect.getRow(data, rowIndex);
            }
        } else if (props.onRowClick) {
            const selection = window.getSelection();
            if (selection && selection.toString().length > 0) return;
            props.onRowClick(e, data);
        } else {
            if ((data._id !== selectedRow) && (e.detail === 1)) {
                props.onRowSelect.getRow(data, rowIndex);
            } else {
                props.onRowSelect.getRow(null, rowIndex);
            }
        }
    }

    const handleRowUpdate = (e, data, id, rowIndex) => {
        props.update && props.update(e, data, id, rowIndex);
    }

    const handleRowDoubleClick = (e, row) => {
        // It will handle the edit redirect on double click
        if (props.editRedirectAllowed) {
            openEditPage(e, row);
        } else if (props.onDoubleClick) {
            props.onDoubleClick(e, row);
        }
    }

    const handleCompanyDoubleClick = (e, row) => {
        if (props?.handleDoubleClick && (e.detail === 2)) {
            props.handleDoubleClick();
        }
    }

    const openEditPage = (e, row) => {
        if (!tableName) return;

        if (tableName === "Search Products") {
            if (checkPermission("products-products/edit-read", permissionsData)) {
                dispatch(openProductLocal(row, TABS_DATA));
            } else {
                toast.error("You don't have permission to edit a product.");
            }
        } else if (tableName === "Client Balance Report") {
            dispatch(setClientMovementsSearchByBalance(row)); // { _id: ... }
            dispatch(openClientMovementsReport(TABS_DATA));
        } else if (tableName === "Product Balance Report") {
            dispatch(setProductMovementsReportDataByBalance(row)); // { _id: ... }
            dispatch(openProductMovementsReport(TABS_DATA));
        } else if (tableName === "Client Isozygio Report") {
            dispatch(setClientMovementsSearchByBalance({_id: row._id, clientName: row.name}));
            dispatch(openClientMovementsReport(TABS_DATA));
        } else if (tableName === "Supplier Balance Report") {
            dispatch(setSupplierMovementsSearchByBalance(row));
            dispatch(openSupplierMovementsReport(TABS_DATA));
        } else if (tableName === "Supplier Isozygio Report") {
            dispatch(setSupplierMovementsSearchByBalance({_id: row._id, supplierName: row.name}));
            dispatch(openSupplierMovementsReport(TABS_DATA));
        } else if (getKeyByName(tableName) === "search_product_movements") {
            if (checkPermission("products-productsmovements/edit-read", permissionsData)) {
                dispatch(openProductMovementLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a product movement.");
            }
        } else if (getKeyByName(tableName) === "search_product_price_list") {
            if (checkPermission("products-pricelist/edit-read", permissionsData)) {
                dispatch(openPriceListLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a price list.");
            }
        } else if (getKeyByName(tableName) === "client_search") {
            if (checkPermission("clients-clients/edit-read", permissionsData)) {
                dispatch(openClientLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a client.");
            }
        } else if (tableName === "Employees Search") {
            dispatch(openEmployeeLocal(row, TABS_DATA));
        } else if (tableName === "Accounting Account Search") {
            dispatch(openAccountingAccountLocal(row, TABS_DATA));
        } else if (tableName === "Accounting Record Search") {
            dispatch(openAccountingRecordLocal(row, TABS_DATA));
        } else if (tableName === "Emron Payments Report") {
            openClient(dispatch, TABS_DATA, company.id, row._id);
        } else if (getKeyByName(tableName) === "supplier_search") {
            if (checkPermission("suppliers-suppliers/edit-read", permissionsData)) {
                dispatch(openSupplierLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a supplier.");
            }
        } else if (getKeyByName(tableName) === "client_movements_search") {
            if (checkPermission("clients-clientmovements/edit-read", permissionsData)) {
                dispatch(openClientMovementLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a client movement.");
            }
        } else if (getKeyByName(tableName) === "supplier_movements_search") {
            if (checkPermission("suppliers-suppliermovements/edit-read", permissionsData)) {
                dispatch(openSupplierMovementLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a supplier movement.");
            }
        } else if (getKeyByName(tableName) === "basic_types_search") {
            if (checkPermission("settings-documenttype/basictypesedit-read", permissionsData)) {
                dispatch(openBasicTypeLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a basic type.");
            }
        } else if (getKeyByName(tableName) === "advanced_types_search") {
            if (checkPermission("settings-documenttype/advancedtypesedit-read", permissionsData)) {
                dispatch(openAdvancedTypeLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit an advance type.");
            }
        } else if (getKeyByName(tableName) === "cash_registers_search") {
            if (checkPermission("cash-cashregisters/edit-read", permissionsData)) {
                dispatch(openCashRegisterLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a cash register.");
            }
        } else if (getKeyByName(tableName) === "pos_search") {
            if (checkPermission("cash-pos/edit-read", permissionsData)) {
                dispatch(openPOSLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a POS.");
            }
        } else if (tableName === "Cheques Search") {
            if (checkPermission("cash-cheques/edit-read", permissionsData)) {
                dispatch(openChequeLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a cheque.");
            }
        } else if (tableName === "Loans Search") {
            if (checkPermission("cash-loans/edit-read", permissionsData)) {
                dispatch(openLoanLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a loan.");
            }
        } else if (getKeyByName(tableName) === "bank_account_search") {
            if (checkPermission("cash-bankaccounts/edit-read", permissionsData)) {
                dispatch(openBankAccountLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a bank account.");
            }
        } else if (getKeyByName(tableName) === "sales_search") {
            if (checkPermission("sales-sales/edit-read", permissionsData)) {
                dispatch(openSaleLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to view a sale.");
            }
        } else if (getKeyByName(tableName) === "buys_search") {
            if (checkPermission("buys-buy/edit-read", permissionsData)) {
                dispatch(openBuyLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a buy.");
            }
        } else if (getKeyByName(tableName) === getKeyByName("Client Payments Search")) {
            if (checkPermission("sales-clientpayments/edit-read", permissionsData)) {
                dispatch(openClientPaymentLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a client payment.");
            }
        } else if (getKeyByName(tableName) === getKeyByName("Supplier Payments Search")) {
            if (checkPermission("buys-supplierpayments/edit-read", permissionsData)) {
                dispatch(openSupplierPaymentLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a supplier payment.");
            }
        } else if (tableName === "Work Movements Search") {
            if (checkPermission("payroll-workmovements/edit-read", permissionsData)) {
                dispatch(openWorkMovementLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a work movement.");
            }
        } else if (tableName === "Work Permits Search") {
            if (checkPermission("payroll-workpermits/edit-read", permissionsData)) {
                dispatch(openWorkPermitLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a work permit.");
            }
        } else if (tableName === "Dcl Search") {
            if (checkPermission("sales-dcl/search-read", permissionsData)) {
                dispatch(openDCLLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a Dcl.");
            }
        } else if (tableName === "Primer Payments Report") {
            if (checkPermission("sales-sales/edit-read", permissionsData)) {
                if (row && row?.invoice_mark) {
                    axios.get(process.env.REACT_APP_API_URL2 + "/sale/get-sale-by-mark", {
                        headers: {"Content-Type": "application/json"},
                        params: {
                            mark: row?.invoice_mark,
                            company: company.id,
                        }
                    }).then((res) => {
                        if (res.data.status === "200") {
                            dispatch(openSaleLocal(res.data.data, TABS_DATA));
                        } else {
                            toast.error("Η πώληση δεν βρέθηκε, παρακαλώ δοκιμάστε αργότερα.");
                        }
                    }).catch((err) => {
                        console.log(err);
                        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                    })
                } else {
                    toast.error("Το παραστατικό δεν έχει εκδοθεί ακόμα.");
                }
            }
        } else if (tableName === "Sales Balance Sheet") {
            if (checkPermission("sales-sales/edit-read", permissionsData)) {
                openSale(dispatch, TABS_DATA, company.id, row._id);
            }
        } else if (tableName === "Quotations Search") {
            if (checkPermission("sales-quotations/edit-read", permissionsData)) {
                dispatch(openQuotationLocal(row, TABS_DATA));
            } else {
                toast.error("You do not have permission to edit a quotation.");
            }
        } else if (tableName === "Client Payments Report") {
            if (checkPermission("sales-clientpayments/edit-read", permissionsData)) {
                openClientPayment(dispatch, TABS_DATA, company.id, row._id);
            }
        } else if (tableName === "Buys Balance Sheet") {
            if (checkPermission("buys-buy/edit-read", permissionsData)) {
                openBuy(dispatch, TABS_DATA, company.id, row._id);
            }
        } else if (tableName === "Supplier Payments Report") {
            if (checkPermission("buys-supplierpayments/edit-read", permissionsData)) {
                openSupplierPayment(dispatch, TABS_DATA, company.id, row._id);
            }
        } else if (tableName === "Prescription Search Visits") {
            dispatch(openEditVisit({id: row.id}, TABS_DATA));
        } else if (tableName === "Prescription Search Prescriptions") {
            dispatch(openPrescription(row.barcode, TABS_DATA));
        } else if (tableName === "Prescription Search Referrals") {
            dispatch(openReferral(row.barcode, TABS_DATA));
        } else if (tableName === "Client Subscriptions Report") {
            openClient(dispatch, TABS_DATA, company.id, row.clientId);
        } else if (tableName === "Prescription Search Drugs") {
            dispatch(setDrugInfoModal(row));
        } else if (tableName === "Fixed Assets Search") {
            dispatch(openFixedAssetLocal(row, TABS_DATA));
        } else if (tableName === "Fixed Asset Movements Search") {
            dispatch(openFixedAssetMovementLocal(row, TABS_DATA));
        } else if (tableName === "Fixed Asset Records Search") {
            dispatch(openFixedAssetRecordLocal(row, TABS_DATA));
        } else if (tableName === "Submitted Vat Declarations Search") {
            dispatch(openSubmittedVatDeclarationLocal(row, TABS_DATA));
        } else if (tableName === "Submitted F4 Declarations Search") {
            dispatch(openSubmittedF4DeclarationLocal(row, TABS_DATA));
        } else if (tableName === "Submitted F5 Declarations Search") {
            dispatch(openSubmittedF5DeclarationLocal(row, TABS_DATA));
        } else if (tableName === "Unregulated Debts Search") {
            dispatch(openDebtLocal(row, TABS_DATA));
        } else if (tableName === "Cards Search") {
            dispatch(openCardLocal(row, TABS_DATA));
        }
    }

    let hideFirstRow = false;

    if (tableName && ((tableName === "Client Contact Points" || tableName === "Edit Client Contact Points") || (tableName === "Supplier Contact Points" || tableName === "Edit Supplier Contact Points"))) {
        if (data && data.length === 1) {
            if (data['0'].name === '' && data['0'].mobile === '' && data['0'].email === '') {
                hideFirstRow = true;
            }
        }
    }

    const tableDataLength = data && data?.length ? data?.length : 0;

    return (
        <tbody>

        {/* Table Filter Row */}
        {(allowFilterTable && data?.length > 0) && (
            <tr className="table-filter-row">
                <TableFilterRow
                    {...props}
                    tableName={tableName}
                    filters={filters}
                    filterFieldValue={filterFieldValue}
                    columns={columns}
                />
            </tr>
        )}
        {/* Table Insert Row */}
        {allowInsertRowFromTop && (
            <tr className="insert-new-row">
                <TableInsertDataRow tableName={tableName} {...props} columns={columns} pRequestData={pRequestData} reqName={reqName}/>
            </tr>
        )}

        {/* Table Data */}
        {
            bodyData && bodyData?.length > 0 ?
                bodyData && bodyData.map((row, rowi) => {
                    if (hideFirstRow) {
                        return <tr onDoubleClick={(e) => handleRowDoubleClick(e, row)}
                                   className={(!isEmpty(selectedRow) && row && (row?._id === selectedRow || row?.id === selectedRow || rowi === selectedRow)) ? 'active-row d-none' : 'inactive-row d-none'}
                                   onClick={(e) => selectRow(e, row, rowi)} key={rowi}>
                            <TableBodyRow quickEditFields={quickEditCustomColumns} checkedRows={checkedRows} selectedRowKey={selectedRowKey} rowIndex={rowi}
                                          dataLength={tableDataLength} tableName={tableName} updateRowData={handleRowUpdate}
                                          columns={columns} data={row} pRequestData={pRequestData} reqName={reqName} permissionsData={permissionsData} />
                        </tr>
                    } else {
                        if (tableName === 'companyModal') {
                            return <tr onDoubleClick={(e) => handleCompanyDoubleClick(e, row)}
                                       className={(!isEmpty(selectedRow) && row && (row?._id === selectedRow || row?._id === selectedRow || rowi === selectedRow)) ? 'active-row' : 'inactive-row'}
                                       onClick={(e) => selectRow(e, row, rowi)} key={rowi}>
                                <TableBodyRow rowIndex={rowi} dataLength={tableDataLength} tableName={tableName}
                                              columns={columns} data={row} permissionsData={permissionsData} />
                            </tr>
                        } else if (tableName === "Client Subscriptions Report") {
                            return <tr style={{backgroundColor: row.status === "Ενεργή" ? "" : "#fa6666"}}
                                       onDoubleClick={(e) => handleRowDoubleClick(e, row)}
                                       className={(!isEmpty(selectedRow) && row && (row?._id === selectedRow || row?.id === selectedRow || rowi === selectedRow)) ? 'active-row' : 'inactive-row'}
                                       onClick={(e) => selectRow(e, row, rowi)} key={rowi}>
                                <TableBodyRow quickEditFields={quickEditCustomColumns}
                                              emronPaymentsMonth={emronPaymentsMonth} checkedRows={checkedRows} selectedRowKey={selectedRowKey}
                                              rowIndex={rowi} dataLength={tableDataLength} tableName={tableName}
                                              updateRowData={handleRowUpdate} columns={columns} data={row}
                                              pRequestData={pRequestData} reqName={reqName} permissionsData={permissionsData} />
                            </tr>
                        } else {
                            return (
                                <React.Fragment key={rowi + " row"}>
                                    <tr onDoubleClick={(e) => handleRowDoubleClick(e, row)}
                                        className={(!isEmpty(selectedRow) && row && (row?._id === selectedRow || row?.id === selectedRow || rowi === selectedRow)) ? 'active-row' : 'inactive-row'}
                                        onClick={(e) => selectRow(e, row, rowi)} key={rowi}>
                                        <TableBodyRow quickEditFields={quickEditCustomColumns}
                                                      emronPaymentsMonth={emronPaymentsMonth} checkedRows={checkedRows} selectedRowKey={selectedRowKey}
                                                      rowIndex={rowi} dataLength={tableDataLength} tableName={tableName}
                                                      updateRowData={handleRowUpdate} columns={columns} data={row} fixedFirstRow={fixedFirstRow}
                                                      pRequestData={pRequestData} reqName={reqName} showAccounting={showAccounting} invoiceType={invoiceType} permissionsData={permissionsData} />
                                    </tr>
                                        <tr  key={rowi + "contacts"} className={`contact-points-wrapper ${row.showContactPoints ? 'open' : ''}`}>
                                            <td colSpan={columns.length} style={{width: "auto"}}>
                                                <table className="nested-contact-table">
                                                    <thead>
                                                    <tr>
                                                        <th className="col-no">Αρ.</th>
                                                        <th className="col-name">Όνομα Επαφής</th>
                                                        <th>Κινητό Τηλέφωνο</th>
                                                        <th>Σταθερό Τηλέφωνο</th>
                                                        <th>Άλλο Τηλέφωνο</th>
                                                        <th>Ηλεκτρονική Διεύθυνση</th>
                                                        <th>Σημειώσεις Επικοινωνίας</th>
                                                        <th className="col-no">Αποδοχή Ειδοποιήσεων</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {row?.contactPoints?.length > 0 && row?.contactPoints?.map((contactPoint, contactPointi) => {
                                                        return (
                                                            <tr key={contactPointi}>
                                                                <td className="col-no">{contactPoint?.id}</td>
                                                                <td className="col-name">{contactPoint?.name}</td>
                                                                <td>{contactPoint?.mobile}</td>
                                                                <td>{contactPoint?.landline}</td>
                                                                <td>{contactPoint?.otherPhone}</td>
                                                                <td>{contactPoint?.email}</td>
                                                                <td>{contactPoint?.contactNotes}</td>
                                                                <td className="col-no">{contactPoint?.acceptsNotifications === "active" ? "Ναί" : "Όχι"}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                </React.Fragment>
                            )
                        }
                    }
                })
                :
                (!allowInsertRow && !allowInsertRowFromTop) && <tr>
                    <td colSpan={columns.length + 1}><span
                        className="tdelement text-center">{t('dateFilterColumn.noRecordsFound')}</span></td>
                </tr>
        }

        {/* Table Insert Row */}
        {allowInsertRow && (
            <tr className="insert-new-row">
                <TableInsertDataRow tableName={tableName} {...props} columns={columns} pRequestData={pRequestData}
                                    reqName={reqName}/>
            </tr>
        )}
        </tbody>
    )
}

export default TableBody;
